import React, { useState } from 'react';

function SurveyStepEleven({ formData, onNext }) {
    const [safetyRating, setSafetyRating] = useState(formData.safetyRating || '');
    const [safetyComments, setSafetyComments] = useState(formData.safetyComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!safetyRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ safetyRating, safetyComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 3: Patient Safety & Service</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How strongly do you believe the pharmacy maintains high standards for patient safety? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`safety-rating-${option}`}
                            name="safetyRating"
                            value={option}
                            checked={safetyRating === option}
                            onChange={() => setSafetyRating(option)}
                        />
                        <label htmlFor={`safety-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={safetyComments}
                    onChange={(e) => setSafetyComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!safetyRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepEleven;
